<div class="example-header">
    <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon fontSet="mdi" fontIcon="mdi-chevron-left"></mat-icon>
    </button>
    <span class="example-header-label">{{ periodLabel }}</span>
    <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon fontSet="mdi" fontIcon="mdi-chevron-right"></mat-icon>
    </button>
</div>
